/* tslint:disable */
/* eslint-disable */
/**
 * 輸送ロット調整API
 * 重量、パレット数、容量制約に基づいてアイテムを輸送ロットに割り当てるAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OptimizeTransportLot200ResponseMovedItemsInner
 */
export interface OptimizeTransportLot200ResponseMovedItemsInner {
    /**
     * 元の発注日
     * @type {Date}
     * @memberof OptimizeTransportLot200ResponseMovedItemsInner
     */
    orderDate: Date;
    /**
     * 新しい発注日
     * @type {Date}
     * @memberof OptimizeTransportLot200ResponseMovedItemsInner
     */
    newOrderDate: Date;
    /**
     * 商品コード
     * @type {string}
     * @memberof OptimizeTransportLot200ResponseMovedItemsInner
     */
    itemCode: string;
    /**
     * 移動数量
     * @type {number}
     * @memberof OptimizeTransportLot200ResponseMovedItemsInner
     */
    moveQuantity: number;
}

/**
 * Check if a given object implements the OptimizeTransportLot200ResponseMovedItemsInner interface.
 */
export function instanceOfOptimizeTransportLot200ResponseMovedItemsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "orderDate" in value;
    isInstance = isInstance && "newOrderDate" in value;
    isInstance = isInstance && "itemCode" in value;
    isInstance = isInstance && "moveQuantity" in value;

    return isInstance;
}

export function OptimizeTransportLot200ResponseMovedItemsInnerFromJSON(json: any): OptimizeTransportLot200ResponseMovedItemsInner {
    return OptimizeTransportLot200ResponseMovedItemsInnerFromJSONTyped(json, false);
}

export function OptimizeTransportLot200ResponseMovedItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): OptimizeTransportLot200ResponseMovedItemsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'orderDate': (new Date(json['order_date'])),
        'newOrderDate': (new Date(json['new_order_date'])),
        'itemCode': json['item_code'],
        'moveQuantity': json['move_quantity'],
    };
}

export function OptimizeTransportLot200ResponseMovedItemsInnerToJSON(value?: OptimizeTransportLot200ResponseMovedItemsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'order_date': (value.orderDate.toISOString().substring(0,10)),
        'new_order_date': (value.newOrderDate.toISOString().substring(0,10)),
        'item_code': value.itemCode,
        'move_quantity': value.moveQuantity,
    };
}

